import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { SetSelectedAssessment } from "../../../Project/Store";
import { SetSelectedPageWithoutUrl } from "../../../../AppMenu/Store";
import { useNavigate } from "react-router-dom";
import ApiHelper from "../../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../../Helpers/EnumHelper";

const ApplicationCardInfoModal = ({ selectedApplication, setSelectedApplication, isInVitrine }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);

  return (
    <>
      <Modal
        size="lg"
        show={selectedApplication?.assessment}
        onHide={() => {
          setSelectedApplication(null);
        }}
        dialogClassName={`custom-modal-dialog ${windowSizeCssClass}`}
        contentClassName="custom-modal-content"
      >
        <div className="bordered">
          <Modal.Header closeButton className="p-0 border-bottom-0 text-18 text-color-gray-light fw-medium">
            <Col xs={"auto"} className={"text-color-gray-dark"}>
              {selectedApplication?.assessment?.name}{" "}
            </Col>
          </Modal.Header>

          <Row className={"justify-content-between mt-3 text-color-gray-light fw-semibold"}>
            <Col xs={"auto"}>{t("inventories")}</Col>

            {!isInVitrine && (
              <Col xs={"auto"}>
                {t("amount")}: {selectedApplication?.assessment?.inventories?.length}
              </Col>
            )}
          </Row>

          {selectedApplication?.assessment?.inventories?.length > 0 ? (
            <Card className="assessment-row py-2">
              {selectedApplication?.assessment?.inventories?.map((inventory, i) => (
                <>
                  <Row key={i + "I"} className=" m-0">
                    <Col xs={"auto"} className={"pe-0"}>
                      <img
                        width={20}
                        height={20}
                        src={ApiHelper.cloudFrontURL + folderEnum.info + inventory.iconImageName}
                        alt={`Inventory image ${i}`}
                      />
                    </Col>
                    <Col xs={"auto"}>{inventory.name}</Col>
                    <Col className={"text-12 align-content-center text-nowrap lh-1"}>
                      {inventory.questionNumber} {t("question")}
                    </Col>
                  </Row>
                  <Row className={"mx-2 mb-2"}>
                    {inventory.scopes?.map((scope, i) => {
                      return (
                        <Col key={i + "IScp"} xs={"auto"} className={"px-0"}>
                          <Button
                            className={"button secondary primary-color  text-10 mx-1"}
                            style={{ height: "20px", padding: "0 5px", cursor: "help" }}
                            title={
                              // if there are any names, join them; otherwise show fallback
                              (scope.subScopes ?? [])
                                .map((ss) => ss.name)
                                .join(", ")
                                .trim() || "alt boyut yok"
                            }
                          >
                            {scope.name}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ))}
            </Card>
          ) : (
            <Card className="assessment-row py-2" style={{ backgroundColor: "#efefef" }}>
              <Row className=" m-0">
                <Col className={"text-color-gray-light "}>{t("noInventoriesAvailable")}</Col>
              </Row>
            </Card>
          )}

          <Row className={"justify-content-between mt-5 text-color-gray-light fw-semibold"}>
            <Col xs={"auto"}>{t("tests")}</Col>
            {!isInVitrine && (
              <Col xs={"auto"}>
                {t("amount")}: {selectedApplication?.assessment?.tests?.length}
              </Col>
            )}
          </Row>
          {selectedApplication?.assessment?.tests?.length > 0 ? (
            <Card className="assessment-row py-2">
              {selectedApplication?.assessment?.tests?.map((test, i) => (
                <>
                  <Row key={i + "I"} className=" m-0">
                    <Col xs={"auto"} className={"pe-0"}>
                      <img
                        width={20}
                        height={20}
                        src={ApiHelper.cloudFrontURL + folderEnum.info + test.iconImageName}
                        alt={`Test image ${i}`}
                      />
                    </Col>
                    <Col xs={"auto"} className={""}>
                      {test.name}
                    </Col>

                    <Col className={"text-12 align-content-center text-nowrap  lh-1"}>
                      {test.questionNumber} {t("question")}
                    </Col>
                  </Row>
                  <Row className={"mx-2 mb-2 "}>
                    {test.scopes?.map((scope, i) => {
                      return (
                        <Col key={i + "TScp"} xs={"auto"} className={"px-0"}>
                          <Button
                            className={"button secondary primary-color  text-10 mx-1"}
                            style={{ height: "20px", padding: "0 5px", cursor: "help" }}
                            title={
                              // if there are any names, join them; otherwise show fallback
                              (scope.subScopes ?? [])
                                .map((ss) => ss.name)
                                .join(", ")
                                .trim() || "alt boyut yok"
                            }
                          >
                            {scope.name}
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ))}
            </Card>
          ) : (
            <Card className="assessment-row py-2" style={{ backgroundColor: "#efefef" }}>
              <Row className=" m-0">
                <Col className={"text-color-gray-light "}>{t("noTestsAvailable")}</Col>
              </Row>
            </Card>
          )}

          <Row className={"justify-content-between mt-5 text-color-gray-light fw-semibold"}>
            <Col xs={"auto"}>{t("surveys")}</Col>
            {!isInVitrine && (
              <Col xs={"auto"}>
                {t("amount")}: {selectedApplication?.assessment?.surveys?.length}
              </Col>
            )}
          </Row>

          {selectedApplication?.assessment?.surveys?.length > 0 ? (
            <Card className="assessment-row py-2">
              {selectedApplication?.assessment?.surveys?.map((survey, i) => (
                <Row key={i + "I"} className="justify-content-between m-0">
                  <Col xs="auto">{survey.name}</Col>
                  <Col xs="auto"></Col>
                </Row>
              ))}
            </Card>
          ) : (
            <Card className="assessment-row py-2 " style={{ backgroundColor: "#efefef" }}>
              <Row className=" m-0 ">
                <Col className={"text-color-gray-light "}>{t("noSurveysAvailable")}</Col>
              </Row>
            </Card>
          )}
          {!isInVitrine && (
            <Row className={" justify-content-between mt-5 pt-5"}>
              <Col xs={"auto"} className={"align-content-center text-20 fw-semibold text-color-gray-dark"}>
                {t("remainingCredits")}: {selectedApplication?.creditAmount}
              </Col>
              <Col xs={"auto"}>
                <Button
                  className="button primary primary-color"
                  style={{ height: "50px", width: "200px" }}
                  onClick={() => {
                    const selectedAssessment = [
                      {
                        creditId: selectedApplication.creditId,
                        label: selectedApplication.assessment?.name,
                        value: selectedApplication.assessment?.id,
                      },
                    ];
                    dispatch(SetSelectedAssessment(selectedAssessment));
                    navigate("/project", { state: { backUrl: "/dash" } });
                    dispatch(SetSelectedPageWithoutUrl({ url: "/project/" }));
                  }}
                >
                  {t("navigateToProjects")}
                </Button>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ApplicationCardInfoModal;
